export const changeState = (route) => ({type: 'CHANGE_STATE', route});

export * from './alertas';
export * from './auth';
export * from './buscaCameras';
export * from './cameras';
export * from './geolocation';



// WEBPACK FOOTER //
// ./src/actions/index.js